import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getGroupsByGame, stopGame } from '../dashboard/dashboardSlice';
import Cookies from "js-cookie";
import api from '../../api';

function Monitor() {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  const [gameId, setGameId] = useState(0);
  const [gameCode, setGameCode] = useState(0);
  const host = window.location.protocol + "//" + window.location.host;

  const groups = useSelector((state) => state.dashboard.groups);

  useEffect(() => {
    const cookieGameId = Cookies.get("game_id");
    const cookieGameCode = Cookies.get("game_code");
    setGameId(cookieGameId);
    setGameCode(cookieGameCode);

    dispatch(getGroupsByGame(cookieGameId));

    const interval = setInterval(() => {
      dispatch(getGroupsByGame(cookieGameId));
    }
      , 5000);

    return () => clearInterval(interval);
  }, []);

  const resetUserHandler = (playerId) => {
    api.resetPlayer(playerId).then((response) => {
      if (response.status === 200) {
        dispatch(getGroupsByGame(gameId));
      }
    });
  }

  const resetGroupHandler = (groupId) => {
    api.resetGroup(groupId).then((response) => {
      if (response.status === 200) {
        dispatch(getGroupsByGame(gameId));
      }
    });
  }

  return (
    <div className="mobileContainer teacher-onboard-screen container-scroll">
      <div className="content-wrapper">
        <div className='content'>
          <h3>{t('teacher.summary.title')}</h3>
          <p>{t('teacher.summary.content')}</p>
          <a className='game-code' href={`/app/digiboard/onboard/${gameCode}`} target='_blank'>www.medievalme.nl/app/digiboard/{gameCode}</a>
          <div className="group-list">
            <div className="player headings">
              <div>Name</div>
              <div>Acc. Assigned</div>
              <div>status</div>
              <div>Actions</div>
            </div>
            <ul>
              {groups && groups.map(group =>
                <li key={group.group_id}>
                  <div className="group">
                    <div className="group-name"><span className='name'>{group.name}</span><button className='reset-button' onClick={e => { resetGroupHandler(group.group_id) }}>Reset</button></div>
                    <ul>
                      {group.players && group.players.map(player =>
                        <li key={player.id} className="player">
                          <div>
                            {player.name && player.name}
                            {!player.name && "not set"}
                          </div>
                          <div>
                            {player.user_assigned ? "assigned" : "not assigned"}
                          </div>
                          <div>
                            {player.status}
                          </div>
                          <div>
                            <button className='reset-button' onClick={e => { resetUserHandler(player.id) }}>Reset</button>
                          </div>
                        </li>
                      )}
                    </ul>
                  </div>
                </li>
              )}
            </ul>
            <div className="stop-game-container">
              <button className='stop-game-button' onClick={e => { dispatch(stopGame(gameId)) }}>Stop Game</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Monitor;